module.exports = __webpack_public_path__ + "img/selected3-min.43acd6eb.png";